export default "__VITE_ASSET__C7xnTM4K__"